import TileTour from "./TileTour";
import React, { useEffect, useState } from "react";
import { Step, Placement } from "react-joyride";
import { useTranslation } from "@me8eon/translation";

const TourStart = ({ tourId, skipSampleQuestion }: { tourId: string, skipSampleQuestion: boolean }) => {
    const [run, setRun] = useState<boolean>(false);
    const [steps, setSteps] = useState<Step[]>([]);
    const t = useTranslation();

    const defineSteps = (tourtype: string) => {
        if (tourtype === "tour1") {
            setSteps(tileSteps);
        } else if (tourtype === "tour2") {
            setSteps(tabSteps);
        } else {
            const isTabPresent =
                document.getElementsByClassName("tab-wrapper")[0];
            setSteps([...tileSteps, ...(isTabPresent ? tabSteps : [])]);
        }
    };

    useEffect(() => {
        defineSteps(tourId);
        setRun(tourId !== "");
    }, [tourId]);

    const tileSteps: Step[] = [
        {
            target: "#tileTour7",
            content: (
                <div>
                    <p><strong>{t("tourData.chat.step1")}</strong></p>
                    <p>{t("tourData.chat.step1_description")}</p>
                </div>
            ),
            disableBeacon: true,
        },
        ...(skipSampleQuestion ? [] : [{
            target: "#tileTour8",
            placement: "left" as Placement,
            content: (
                <div>
                    <p><strong>{t("tourData.chat.step2")}</strong></p>
                    <p>{t("tourData.chat.step2_description")}</p>
                </div>
            ),
        }]),
        {
            target: "#tileTour9",
            content: (
                <div>
                    <p><strong>{t("tourData.chat.step3")}</strong></p>
                    <p>{t("tourData.chat.step3_description")}</p>
                </div>
            ),
        },
        {
            target: "#tileTour10",
            placement: "right" as Placement,
            content: (
                <div>
                    <p><strong>{t("tourData.chat.step4")}</strong></p>
                    <p>{t("tourData.chat.step4_description")}</p>
                </div>
            ),
        },
    ];

    const tabSteps: Step[] = [
        // {
        //     target: "#tabTour1",
        //     content: t("tourData.tab.step1"),
        //     disableBeacon: true,
        // },
        // {
        //     target: "#tabTour2",
        //     content: t("tourData.tab.step2"),
        // },
        // {
        //     target: "#tabTour3",
        //     content: t("tourData.tab.step3"),
        // },
    ];

    const starTour = (e: any) => {
        const element = document.querySelector('[data-test-id="button-beacon"]') as HTMLElement;
        if (element) {
            element.click();
        } else {
            e.preventDefault();
            defineSteps("complete");
            setRun(true);
        }
    };

    return (
        <>
            <TileTour steps={steps} run={run} onTourEnd={() => setRun(false)} />
            <div className="fixed">
                <button
                    onClick={starTour}
                    className="tour-button"
                    data-testid="tourStart"
                >
                    {t("tourData.userActions.start_tour")}
                </button>
            </div>
        </>
    );
};

export default TourStart;
